import {ChipTone} from './skins';

const CHIP_STYLES: Record<ChipTone, {background: string; lineColor: string}> = {
    [ChipTone.Gold]: {
        background: 'linear-gradient(135deg,#E7CD77 0%,#C9A544 26%,#F6ECB0 44%,#B78F34 62%,#E0C164 100%)',
        lineColor: 'rgba(120,80,20,0.55)',
    },
    [ChipTone.Silver]: {
        background: 'linear-gradient(135deg,#DFE0E2 0%,#B9BCC2 40%,#EEF0F2 55%,#A9ADB4 75%,#CFD2D7 100%)',
        lineColor: 'rgba(90,94,102,0.6)',
    },
    [ChipTone.Sage]: {
        background: 'linear-gradient(135deg,#D8DAD3 0%,#A9ADA2 40%,#EEF0EA 55%,#9A9E92 75%,#C3C6BC 100%)',
        lineColor: 'rgba(90,94,88,0.6)',
    },
};

export function Chip({tone, className}: {tone: ChipTone; className: string}) {
    const {background, lineColor} = CHIP_STYLES[tone];

    return (
        <div
            className={`h-[39px] w-[51px] rounded-[14%] shadow-[inset_0_0_0_1.7px_rgba(120,90,20,0.35),inset_0_1.4px_2.7px_rgba(255,255,255,0.35)] ${className}`}
            style={{background}}
        >
            <svg aria-hidden className="h-full w-full" viewBox="0 0 50 40">
                <g fill="none" stroke={lineColor} strokeWidth="1.3">
                    <path d="M1 14h48M1 26h48M18 1v38M32 1v38" />
                    <rect x="18" y="14" width="14" height="12" />
                </g>
            </svg>
        </div>
    );
}

export function ContactlessMark({color, className}: {color: string; className: string}) {
    return (
        <svg aria-hidden className={`h-[27px] w-[27px] rotate-90 ${className}`} viewBox="0 0 24 24" style={{color}}>
            <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M8 8a7 7 0 0 1 0 8" />
                <path d="M11.5 5a11 11 0 0 1 0 14" />
                <path d="M15 2.5a15 15 0 0 1 0 19" />
            </g>
        </svg>
    );
}

export function MastercardMark({wordColor, className}: {wordColor: string; className: string}) {
    return (
        <div className={className}>
            <svg aria-hidden className="block h-auto w-full" viewBox="0 0 48 30">
                <circle cx="18" cy="15" r="14" fill="#EB001B" />
                <circle cx="30" cy="15" r="14" fill="#F79E1B" />
                <path d="M24 4.5a14 14 0 0 1 0 21 14 14 0 0 1 0-21z" fill="#FF5F00" />
            </svg>
            <div className="mt-px text-center text-[8px] font-semibold lowercase tracking-[0.02em] opacity-90" style={{color: wordColor}}>
                mastercard
            </div>
        </div>
    );
}
